import React from 'react';
import { Button, CircularProgress, FormGroup, InputLabel, Stack, alpha } from '@mui/material';
import { theme } from '../../../../../common/styles/theme';
import { Paper } from '../../../../../common/components/Paper/Paper';
import { CallLangMenuHOC } from '../../CallLangMenu/hocs/CallLangMenuHOC';
import { INewCallPanelProps } from './types';

export function NewCallPanel({
    lang,
    isCreating,
    hasLastMeeting,
    onJoinLast,
    onCreate,
    onOpenSettings,
}: INewCallPanelProps) {
    const IconSettings = require('!!@svgr/webpack!../../shared/icons/settings-md.svg').default;

    return (
        <Stack
            gap={.5}
            sx={{
                width: 1,
            }}
        >
            <Paper
                className={'start-form'}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: 1,
                    padding: 3,
                    gap: 1,
                    border: `2px solid ${theme.palette.primary.main}`,
                    boxShadow: `0 4px 16px ${alpha(theme.palette.primary.main, .15)}`,

                    'fieldset': {
                        margin: 0,
                        padding: 0,
                        border: 0,
                        minWidth: 0,
                        width: 1,
                    },

                    'legend': {
                        padding: 0,
                        margin: 0,
                        fontSize: '12px',
                    },

                    'label': {
                        width: 1,
                        fontSize: '12px',
                    },

                    'input, textarea': {
                        width: 1,
                    },
                }}
            >
                <FormGroup>
                    <InputLabel
                        sx={{
                            mb: theme.spacing(1),
                        }}
                    >
                        Learning language:
                    </InputLabel>

                    <CallLangMenuHOC />
                </FormGroup>

                {hasLastMeeting &&
                    <Button
                        variant={'outlined'}
                        onClick={onJoinLast}
                        sx={{
                            mt: 1,
                        }}
                    >
                        Return to your last meeting
                    </Button>
                }

                <Button
                    variant={'contained'}
                    disabled={!lang || isCreating}
                    startIcon={isCreating && <CircularProgress size={16} color={'inherit'} />}
                    onClick={onCreate}
                    sx={{
                        mt: hasLastMeeting ? 0 : 1,
                    }}
                >
                    New meeting
                </Button>
            </Paper>

            <Button
                sx={{
                    alignSelf: 'flex-start',
                    ml: 1,
                    color: theme.palette.grey[400],
                    fontSize: theme.typography.subtitle1,

                    'svg': {
                        width: theme.spacing(2),
                        height: theme.spacing(2),
                    },

                    '&:hover': {
                        color: theme.palette.grey[900],
                    },
                }}
                startIcon={<IconSettings />}
                onClick={onOpenSettings}
            >
                Input/Output settings
            </Button>
        </Stack>
    );
}
